// Receive Getters

export const getReceiveList = state => {
  return state.receiveList
}

export const getReceiveInfo = state => {
  return state.receiveInfo
}

export const getPendingReceiveCount = state => {
  return state.pendingReceiveCount
}
